// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 当日策略表
import current from '@/views/share/current';
//用户管理
import user from "../views/user/user";
//回款计划详情
import hkjh_xq from "../views/share/hkjh_xq";
//开票时间
import kpsj_xq from "../views/share/kpsj_xq";
//部门管理
import department from "../views/share/department";
//
import depart_xq from "../views/share/depart_xq";
//部门详情
import bumen_xq from "../views/share/bumen_xq";

/**
 * 数据统计
 * */
import sales from "../views/statement/sales";
import bid from "../views/statement/bid";
import depart from "../views/statement/depart";


// 启用路由
Vue.use(Router);


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/share/current',
            name: '项目管理',
            component: current,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/user/user',
          name: '用户管理',
          component: user,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/share/hkjh_xq',
          name: '回款计划',
          component: hkjh_xq,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/share/kpsj_xq',
          name: '开票时间',
          component: kpsj_xq,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/share/department',
          name: '部门管理',
          component: department,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/share/depart_xq',
          name: '部门业绩详情',
          component: depart_xq,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/state/depart',
          name: '部门商洽效率分析',
          component: depart,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/state/bid',
          name: '招标商洽效率分析',
          component: bid,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/state/sales',
          name: '经营销量分析',
          component: sales,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/state/bumen_xq',
          name: '部门详情',
          component: bumen_xq,
          meta: {
            requireAuth: true
          }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js